<div class="chip" [class.active]="selected" (click)="onClick()">
  {{ item.value }}
</div>
